import { Component, inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { PageSpinnerComponent } from './shared/components/page-spinner/page-spinner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    PageSpinnerComponent
  ],
  template: '<router-outlet></router-outlet><app-page-spinner></app-page-spinner>'
})
export class AppComponent {
  title = 'Buzzwave Go';

  constructor() {
    const document = inject(DOCUMENT);
    if (!isPlatformBrowser(inject(PLATFORM_ID))) return;
    inject(Router).events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel) {
        document.getElementById('buzzwave-initial-loader')?.remove();
      }
    });
  }
}
